import React from 'react'
import LandingPage from './LandingPage'
import Register from './Register';
import Sports from './Sports_Club_Registration';
import Association from './Association';
import Empowerment from './Empowerment'
import Header from './Header';
import Terms from './Terms'
import './App.css'


import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
function App() {
  return (

   
      <div className="app">
         <Router>
      <Header />
        <Routes>
          
        <Route path="/*" element={<>
          
            <LandingPage />
          </>} />
       
        <Route path="/Youth_Registration" element={<>
          
          <Register/>
        </>} />
        <Route path="/Sports_Club_Registration" element={<>
          
          <Sports/>
        </>} />
        <Route path="/Associations_Registration" element={<>
          
          <Association/>
        </>} />
        <Route path="/Empowerment_Application" element={<>
          
          <Empowerment/>
        </>} />
        <Route path="/terms" element={<>
           
           <Terms />
           
         </>} />
      
         
         
        </Routes>
        </Router>
      </div>
   
  )
}

export default App